module.exports = __webpack_public_path__ + "img/kourindou boutique.c3d32486.png";